import React from 'react';

import { Select as MuiSelect } from '@mui/material';

import Input from './Input';
import { type SelectProps } from './types';

const Select: React.FC<SelectProps> = React.forwardRef(({ errorMessage, ...props }, ref) => (
    <MuiSelect input={<Input inputRef={ref} label={props.label} name={props.name} errorMessage={errorMessage} />} {...props}>
        {props.children}
    </MuiSelect>
));

export default Select;
